import { rootStore } from 'store';
import * as hmiclientbase from './hmiclientbase';

export let HisttoryConfig: any = {};
export let ConstantsXML: any = {};
export let LastAlarms: any = {};

let GlobalParams: any = {};

export interface IDataHistory {
    ID: string;
    V: number[];
    T: number[];
    Q?: number[];
}

export default function ClientsDataRegisterCommands() {
    let idpro = window.GetIdAndHost().id;

    fetch('/ixyber/vision/File/ConstantXML?idpro=' + idpro)
        .then((res) => res.json())
        .then(
            (result) => {
                SetConstantXML(result);
            },
            // Примечание: важно обрабатывать ошибки именно здесь, а не в блоке catch(),
            // чтобы не перехватывать исключения из ошибок в самих компонентах.
            (error) => {}
        );

    hmiclientbase.ClientRegisterCommands();
}

function SetConstantXML(_constants: any) {
    ConstantsXML = _constants;
    if (_constants != '') {
        let _constantsxml = new DOMParser().parseFromString(_constants, 'text/xml');
        ConstantsXML = _constantsxml.documentElement.firstElementChild;

        let constants = ConstantsXML.querySelectorAll('[name]');
        for (let numconst = 0; numconst < constants.length; numconst++) {
            constants[numconst].setAttribute('name', constants[numconst].getAttribute('name').toUpperCase());
        }

        let variables = ConstantsXML.querySelectorAll("[type='uservariable']");
        for (let i = 0; i < variables.length; i++) {
            let Name = variables[i].getAttribute('name').toUpperCase();
            let FullName = variables[i].parentElement.getAttribute('type').toUpperCase() + '.' + Name;

            let type = variables[i].children[0].getAttribute('datatype');
            let value = variables[i].children[0].getAttribute('value');
            if (type == 'number') {
                if (!isNaN(value)) {
                    value = Number(value);
                }
            } else if (type == 'boolean') {
                value = value.toUpperCase() == 'TRUE' || value == '1';
            }

            GlobalParams[FullName] = {};
            GlobalParams[FullName].V = value;
            GlobalParams[FullName].T = new Date();
            GlobalParams[FullName].N = FullName;
            GlobalParams[FullName].Q = 0;
            GlobalParams[FullName].Type = type;
        }
    }
}

export function SetParamGlobal(name: string, value: any): boolean {
    let res = false;
    try {
        if (name.startsWith('window') || (window as { [key: string]: any })[name] != null) {
            eval(name + ' = ' + value);
            res = true;
        } else {
            name = name.toUpperCase();
            if (GlobalParams[name] != null) {
                let type = GlobalParams[name].Type;
                if (type == 'number') {
                    value = Number(value);
                } else if (type == 'boolean') {
                    value = value.toUpperCase() == 'TRUE' || value == '1';
                }

                GlobalParams[name].V = value;
                GlobalParams[name].T = new Date();
                res = true;
            }
        }
    } catch (ex: any) {
        console.log(ex.toString());
    }

    return res;
}

export function GetParamGlobal(name: string): any {
    let res = null;
    if (name.startsWith('window') || (window as { [key: string]: any })[name] != null) {
        //eval(name + " = " + value);
    } else {
        name = name.toUpperCase();
        res = GlobalParams[name];
    }

    return res;
}

export function GetHistorySettings() {
    let res: any = {};
    let xhr = new XMLHttpRequest();
    xhr.open('GET', '/ixyber/vision/File/HistorySettings', false);
    xhr.onload = function (e) {
        if (xhr.readyState === 4) {
            if (xhr.status === 200) {
                res = JSON.parse(JSON.parse(xhr.responseText));
            } else {
                console.error(xhr.statusText);
            }
        }
    };
    xhr.onerror = function (e) {
        console.error(xhr.statusText);
    };
    xhr.send(null);
    return res;
}

export function SetHistorySettings(id: number, settings: any) {
    let histsettings = GetHistorySettings();

    histsettings[id] = settings;

    let formData = new FormData();

    formData.append('newtext', JSON.stringify(histsettings));

    fetch(`/ixyber/vision/File/HistorySettings`, {
        method: 'POST',
        cache: 'no-cache',
        body: formData
    })
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.json();
        })
        .catch((error) => {
            console.log('error', error);
            return {};
        });
}
